module.exports = __webpack_public_path__ + "img/director-test-icon6.95de0578.png";